/* eslint-disable prefer-const */
import useWidgetBadges from "@insite/client-framework/Common/Hooks/useWidgetBadges";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import updateQuantity from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateQuantity";
import updateUnitOfMeasure from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/UpdateUnitOfMeasure";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxPresentationProps, CheckboxProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import DatePicker, { DatePickerPresentationProps, DatePickerState } from "@insite/mobius/DatePicker";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Img, { ImgProps } from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner/LoadingSpinner";
import Radio, { RadioComponentProps } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupComponentProps } from "@insite/mobius/RadioGroup";
import TextField, { TextFieldPresentationProps, TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import FieldSetPresentationProps, { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import submitCreateSubscriptionForm from "@TKCCP/Handler/TkccpCreateSubscriptionHandler";
import resetSubscribedProduct from "@TKCCP/Handler/TkccpResetSubscribedDataHandler";
import setSubscriptionProductIsSelected from "@TKCCP/Handler/TkccpSelectedSubscriptionProductHandler";
import loadSubscriptionProductData from "@TKCCP/Handler/TkccpSubscriptionProductHandler";
import CustomApplicationState from "@TKCCP/Store/CustomHandlerCreator/CustomApplicationState";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";
import { SubscriptionProductServiceCollectionModel } from "@TKCCP/Types/ApiModels";
import MySubscriptionProductListLine from "@TKCCP/Widgets/MySubscription/MySubscriptionProductListLine";
import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    productInfo: ProductInfo;
}

export interface CreateSubscriptionSytles {
    checkboxGroup?: FieldSetGroupPresentationProps<CheckboxGroupComponentProps>;
    checkbox?: CheckboxPresentationProps;
    subscriptionMainContainer?: GridContainerProps;
    subscriptionGirdItem?: GridItemProps;
    subscriptionSubGridItem?: GridItemProps;
    selectedCheckbox?: CheckboxPresentationProps;
    image?: LazyImageProps;
    img?: ImgProps;
    priceLabelText?: TypographyPresentationProps;
    productLabelText?: TypographyPresentationProps;
    itemLabelText?: TypographyPresentationProps;
    amountLabelText?: TypographyPresentationProps;
    nameWrapper?: InjectableCss;
    NoendDateWrapper?: InjectableCss;
    priceWrapper?: InjectableCss;
    quantityWrapper?: InjectableCss;
    subscriptionWrapper?: InjectableCss;
    dateWrapper?: InjectableCss;
    dateSubmitWrapper: GridItemProps;
    qunaityField?: TextFieldProps;
    subscriptionNameField?: TextFieldProps;
    startDatePicker?: DatePickerPresentationProps;
    endDatePicker?: DatePickerPresentationProps;
    submitButton?: ButtonPresentationProps;
    centeringWrapper?: InjectableCss;
    radioWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    radioGroup?: FieldSetGroupPresentationProps<RadioGroupComponentProps>;
    radioButton?: FieldSetPresentationProps<RadioComponentProps>;
    paymentDetailsWrapper: GridItemProps;
    paymentHeading?: TypographyPresentationProps;
    paymentWrap?: InjectableCss;
    paymentChildrenWrap?: InjectableCss;
}

export const CreateSubscriptionSytles: CreateSubscriptionSytles = {
    checkboxGroup: {
        css: css`
            align-items: flex-start;
            height: 100%;
            justify-content: center;
        `,
    },
    selectedCheckbox: {
        css: css`
            margin-right: 10px;
        `,
    },
    subscriptionGirdItem: {
        css: css`
            flex-direction: column;
            width: 100%;
            max-width: 100%;
            flex-basis: auto;
            position: relative;
        `,
    },
    subscriptionSubGridItem: {
        css: css`
            border-top: 1px solid #cecece;
            /* border-bottom: 1px solid #cecece; */
            width: 100%;
            max-width: 100%;
            flex-basis: auto;
            padding: 30px 0px;
            margin: 10px 0px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        padding-bottom: 10px;
                    `,
                    css`
                        flex-direction: column;
                        padding-bottom: 10px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    img: {
        css: css`
            display: flex;
            align-items: flex-start;
            & a {
                width: 100px;
            }

            & img {
                position: relative;
                width: 100px;
            }
        `,
    },
    nameWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            margin-left: 30px;
            width: 400px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: 0px;
                    `,
                    css`
                        margin-left: 0px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    NoendDateWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 5px;
        `,
    },
    priceWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            margin-left: 30px;
            flex-basis: 150px;
            & legend {
                font-size: 16px;
                margin-bottom: 10px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: 0px;
                        flex-basis: auto;
                    `,
                    css`
                        margin-left: 0px;
                        flex-basis: auto;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    productLabelText: {
        css: css`
            font-weight: bold;
            color: #7b7b7b;
        `,
    },
    itemLabelText: {
        css: css`
            font-weight: bold;
            color: #000;
        `,
    },
    priceLabelText: {
        css: css`
            font-weight: bold;
            color: #7b7b7b;
        `,
    },
    amountLabelText: {
        css: css`
            color: #7b7b7b;
        `,
    },

    quantityWrapper: {
        css: css`
            margin-left: 80px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-left: 0px;
                        margin-top: 15px;
                    `,
                    css`
                        margin-left: 0px;
                        margin-top: 15px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },

    qunaityField: {
        css: css`
            width: 70px !important;
        `,
    },
    subscriptionNameField: {
        css: css`
            display: flex;
        `,
    },
    centeringWrapper: {
        css: css`
            width: 100%;
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },

    dateWrapper: {
        css: css`
            display: flex;
            width: 100%;
            max-width: 100%;
            flex-basis: auto;

            & > div {
                margin-right: 30px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        display: grid;
                        grid-template-columns: 45% 45%;
                        & > div > div {
                            width: 100%;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
    startDatePicker: {
        calendarIconProps: {
            css: css`
                width: 28px !important;
                padding: 8px 4px !important;
            `,
        },
        clearIconProps: {
            css: css`
                width: 28px !important;
                padding: 8px 4px !important;
            `,
        },
    },
    endDatePicker: {
        calendarIconProps: {
            css: css`
                width: 28px !important;
                padding: 8px 4px !important;
            `,
        },
        clearIconProps: {
            css: css`
                width: 28px !important;
                padding: 8px 4px !important;
            `,
        },
    },
    submitButton: {
        css: css`
            margin-top: 0px;
            margin-bottom: 25px;
        `,
    },
    dateSubmitWrapper: {
        css: css`
            display: flex;
            flex-basis: auto;
            max-width: 100%;
            width: 100%;
            align-items: flex-end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        align-items: center;
                    `,
                    css`
                        flex-direction: column;
                        align-items: center;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    radioWrapper: {
        css: css`
            display: flex;
            flex-basis: auto;
            max-width: 100%;
            width: 100%;
            align-items: flex-end;
            border: 1px solid lightgrey;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-wrap: wrap;
                    `,
                    css`
                        flex-wrap: wrap;
                    `,
                    null,
                    css`
                        flex-wrap: wrap;
                        width: max-content;
                        margin-right: 17px;
                    `,
                    null,
                ])}
        `,
    },
    radioGroup: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: start;
            align-items: start;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 20px;
                        margin-bottom: 20px;
                    `,
                    css`
                        margin-top: 20px;
                        margin-bottom: 20px;
                    `,
                    css`
                        flex-wrap: wrap;
                        width: 100%;
                        grid-column: 1 / 3;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    radioButton: {
        css: css`
            margin: 10px 20px 5px 0;
        `,
    },
    subscriptionWrapper: {
        css: css`
            align-self: start;
            margin-top: 10px;
            margin-bottom: 10px;
            > div[class^="FormFieldStyle"] {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 30px;
            }

            div[class^="FormInputWrapper"] {
                > input[class^="InputStyle"] {
                    width: 300px;
                    opacity: 1;
                    font-size: 15px;
                    font-weight: 500;
                }
            }
        `,
    },
    paymentDetailsWrapper: {
        css: css`
            display: flex;
            width: 100%;
            max-width: 100%;
            flex-basis: 100%;
            flex-direction: row;
        `,
    },
    paymentHeading: {
        css: css`
            font-weight: bold;
            font-size: 30px;
        `,
    },
    paymentWrap: {
        css: css`
            display: grid;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            grid-template-columns: repeat(3, 31.33%);
            grid-column-gap: 30px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        display: flex;
                        gap: 10px;
                    `,
                    css`
                        flex-direction: column;
                        display: flex;
                        gap: 10px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    paymentChildrenWrap: {
        css: css`
            width: 100%;
        `,
    },
};

const styles = CreateSubscriptionSytles;

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        SubscribedProducts: state.tKCCPData.SubscriptionProductStore?.products,
        realtimeProductList: state.tKCCPData.SubscriptionProductStore.productInfoBySubscription,
        selectedSubSubscriptionList: state.tKCCPData.SubscriptionProductStore.setSubscriptionProductIsSelected,
        CustomerId: state.context.session.billToId || "",
        UserProfileId: state.context.session.userProfileId || "",
        SubscribedProductsNameList: state.tKCCPData.SubscriptionProductStore?.setSubscribedProduct,
        isPunchOutSubFlag: state.context.session?.userRoles?.split(", ").some(val => {
            return val === "PunchOut";
        }),
    };
};
const mapDispatchToProps = {
    updateUnitOfMeasure,
    updateQuantity,
    loadSubscriptionProductData,
    setSubscriptionProductIsSelected,
    submitCreateSubscriptionForm,
    resetSubscribedProduct,
};

interface CreateSubscriptionsProps {
    product: any;
    updateQuantity: any;
    updateUnitOfMeasure: any;
    productInfo: any;
    setSubscriptionProductIsSelected: any;
    selectedSubSubscriptionList: [] | any;
    allListOfProducts: [] | any;
    editProductPageFlag: boolean;
}

export const SubscriptionProductList: React.FC<CreateSubscriptionsProps> = ({
    product,
    updateUnitOfMeasure,
    updateQuantity,
    productInfo,
    setSubscriptionProductIsSelected,
    selectedSubSubscriptionList,
    allListOfProducts,
    editProductPageFlag,
}) => {
    if (!(productInfo && Object.keys(productInfo).length)) {
        return null;
    }

    const [selectedProduct, setSelectedProduct] = useState(false);
    const [quantity, setQuantity] = useState(
        product?.isActiveSubscriptionProductQty || productInfo?.qtyOrdered?.toString() || 1,
    );

    // error message

    const [qtyError, setQtyError] = useState("");

    useEffect(() => {
        if (selectedSubSubscriptionList.length) {
            const isSelectedFlag = selectedSubSubscriptionList.find((val: any) => {
                return val.ProductId === product.productId;
            });
            setSelectedProduct(!!isSelectedFlag);
        } else {
            setSelectedProduct(false);
        }
    }, [selectedSubSubscriptionList]);

    useEffect(() => {
        if (product.isActiveSubscriptionProduct) {
            setSubscriptionProductIsSelected({
                ProductId: product.productId,
                IsActive: true,
                ProductERPNumber: product.productERPNumber,
                UnitOfMeasure: product.productUnitOfMeasureDescription,
                QtyOrdered: Number(quantity),
                editProductPageFlag,
            });
        }
    }, []);

    const productContext: ProductContextModel = {
        product,
        productInfo,
        onQtyOrderedChanged: qtyOrdered => {
            updateQuantity({ productId: product["productId"], qtyOrdered });
        },
        onUnitOfMeasureChanged: unitOfMeasure => {
            updateUnitOfMeasure({ productId: product["productId"], unitOfMeasure });
        },
    };
    const { imageBadges, textBadges } = useWidgetBadges({ productContext });
    const selectChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        setSubscriptionProductIsSelected({
            ProductId: product.productId,
            IsActive: value,
            ProductERPNumber: product.productERPNumber,
            UnitOfMeasure: product.productUnitOfMeasureDescription,
            QtyOrdered: value ? Number(quantity) : 1,
            editProductPageFlag,
        });
    };

    const qtyChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        // const value = event.target.value;
        // setQuantity(value);

        const newQuantity = event.target.value;
        const parsedQuantity = Number(newQuantity);

        let existingQuantityChangeFlag = selectedSubSubscriptionList.some((productVal: any) => {
            return productVal.ProductId === product.productId;
        });

        if (existingQuantityChangeFlag) {
            setSubscriptionProductIsSelected({
                IsActive: true,
                ProductERPNumber: product.productERPNumber,
                ProductId: product.productId,
                UnitOfMeasure: product.productUnitOfMeasureDescription,
                QtyOrdered: parsedQuantity,
                updateExistingProduct: true,
                editProductPageFlag,
            });
            existingQuantityChangeFlag = false;
        }

        if (parsedQuantity <= 0) {
            setQtyError("Quantity cannot be less than 0");
            setQuantity(0);
        } else {
            setQtyError("");
            setQuantity(parsedQuantity);
        }
    };

    // const keyPressHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
    //     if (event.which === 13) {
    //         (event.target as any).blur();
    //     }
    // };
    return (
        <ProductContext.Provider value={productContext}>
            <GridItem {...styles.subscriptionSubGridItem}>
                <StyledWrapper {...styles.img}>
                    <Checkbox
                        {...styles.selectedCheckbox}
                        checked={selectedProduct}
                        onChange={selectChangeHandler}
                        data-test-selector="myListDetails_selectRowCheckbox"
                    />

                    <ProductImage product={productContext} />
                </StyledWrapper>

                <StyledWrapper {...styles.nameWrapper}>
                    {product.brand && <ProductBrand brand={product.brand} />}
                    <ProductDescription product={productContext} />
                    <ProductPartNumbers
                        productNumber={product.productERPNumber}
                        customerProductNumber={product?.customerProductNumber || ""}
                        manufacturerItem={product.manufacturerItem || ""}
                    />
                </StyledWrapper>

                <StyledWrapper {...styles.priceWrapper}>
                    <ProductPrice product={productContext} showSavings={true} />
                </StyledWrapper>

                <StyledWrapper {...styles.quantityWrapper}>
                    <TextField
                        label={translate("Qty")}
                        value={quantity}
                        data-test-selector="subscription_quantityNumber"
                        type="number"
                        max={999999}
                        {...styles.qunaityField}
                        error={qtyError}
                        onChange={qtyChangeHandler}
                        // onKeyPress={keyPressHandler}
                    />
                    {/* {product.product.unitOfMeasures && product.product.unitOfMeasures.length > 1 && (
                    <GridItem>
                        <ProductUnitOfMeasureSelect disabled={false} />
                    </GridItem>
                )} */}
                    {/* <GridItem>
                    <ProductQuantityOrdered />
                </GridItem> */}
                </StyledWrapper>
            </GridItem>
        </ProductContext.Provider>
    );
};

export const CreateSubsciptions = ({
    updateQuantity,
    updateUnitOfMeasure,
    SubscribedProducts,
    loadSubscriptionProductData,
    realtimeProductList,
    setSubscriptionProductIsSelected,
    selectedSubSubscriptionList,
    CustomerId,
    UserProfileId,
    submitCreateSubscriptionForm,
    SubscribedProductsNameList,
    isPunchOutSubFlag,
    resetSubscribedProduct,
}: Props) => {
    useEffect(() => {
        SubscribedProductsNameList;
        loadSubscriptionProductData({
            SubscriptionId: "",
            customerBillToId: CustomerId,
        });
        return () => {
            resetSubscribedProduct({});
        };
    }, []);

    if (isPunchOutSubFlag) {
        return null;
    }

    // site messages

    const subscriptionNameMessage = siteMessage("SubscriptionName_Required");
    const subscriptionNameInvalid = siteMessage("SubscriptionName_invalid_Required");
    const subscriptionPoNoInvalid = siteMessage("SubscriptionPoNumber_invalid_Required");
    const paymentMethodMessage = siteMessage("PaymentMethod_required");
    const poNumberMessage = siteMessage("PoNumber_required");
    const userNameMessage = siteMessage("UserName_required");
    const sameNameMessage = siteMessage("same_name");

    // const { products, productInfoBySubscription } = SubscribedProducts;
    const [startDate, setStartDate] = React.useState<Date | undefined>(new Date());
    const [endDate, setEndDate] = React.useState<Date | undefined>(undefined);
    const [hasEndDate, setHasEndDate] = React.useState(false);
    const [hasSameName, setHasSameName] = React.useState(false);
    const [repeatPeriod, setRepeatPeriod] = React.useState("30");
    const [isSubmitted, setIsSubmitted] = React.useState(false);
    const [subscriptionName, setSubscriptionName] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("");
    const [poNumber, setPoNumber] = useState("");
    const [userName, setUerName] = useState("");
    const toasterContext = useContext(ToasterContext);
    const history = useHistory();
    const [suscribedProductsName, setSuscribedProductsName] = useState(SubscribedProductsNameList);

    // error messages
    const [SameNameError, setSameNameError] = useState(sameNameMessage);
    const [subscriptionNameError, setSubscriptionNameError] = React.useState(subscriptionNameMessage);
    const [paymentMethodError, setpaymentMethodError] = React.useState(paymentMethod);
    const [poNumberError, setpoNumberError] = React.useState(poNumberMessage);
    const [userNameError, setuserNameError] = React.useState(userNameMessage);
    const [frequencyError, setFrequencyError] = React.useState(subscriptionNameMessage);

    const startDateChangeHandler = ({ selectedDay }: DatePickerState) => {
        setStartDate(selectedDay || new Date());
        if (selectedDay && endDate && selectedDay > endDate) {
            setEndDate(undefined);
            setHasEndDate(false);
        }
    };

    //
    const hasEndDateChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        if (hasEndDate) {
            setEndDate(undefined);
            setHasEndDate(false);
        }
    };
    //

    const endDateChangeHandler = ({ selectedDay }: DatePickerState) => {
        console.log(selectedDay, "selectedDay");
        setEndDate(selectedDay);
        setHasEndDate(!!selectedDay);
    };

    //

    const validateForm = () => {
        let isValid = true;

        if (!repeatPeriod) {
            setSameNameError("Please select a repeat period"); // Set error message for validation
            isValid = false;
        }
        return isValid;
    };
    const repeatPeriodChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRepeatPeriod(event.currentTarget.value);
        // setSameNameError("");
    };

    // validate Subscription name

    const validateExtension = (nameValue: string, fiedlName: string) => {
        let regex = new RegExp("^[a-zA-Z0-9]+$");
        let trimmedInput = nameValue.trim();
        const nameValueError =
            !nameValue || nameValue?.length <= 0 || nameValue !== trimmedInput
                ? nameValue !== trimmedInput
                    ? (subscriptionNameInvalid as string)
                    : (subscriptionNameMessage as string)
                : "";
        const PoNoValueError =
            !nameValue || nameValue?.length <= 0 || nameValue !== trimmedInput
                ? nameValue !== trimmedInput
                    ? (subscriptionPoNoInvalid as string)
                    : (poNumberMessage as string)
                : "";
        const UserNameValueError =
            !nameValue || nameValue?.length <= 0 || nameValue !== trimmedInput
                ? nameValue !== trimmedInput
                    ? (subscriptionNameInvalid as string)
                    : (userNameMessage as string)
                : "";
        if (fiedlName === "subscriptionName") {
            setSubscriptionNameError(nameValueError);
        } else if (fiedlName === "poNumber") {
            setpoNumberError(PoNoValueError);
        } else if (fiedlName === "userName") {
            setuserNameError(UserNameValueError);
        }
        return !nameValueError;
    };

    const subscriptionNameHandler = (event: ChangeEvent<HTMLInputElement>) => {
        const nameValue = event.target.value;
        setSubscriptionName(nameValue);
        validateExtension(nameValue, "subscriptionName");

        // Name Validation

        const isNameInProducts = suscribedProductsName.some(product => product.name === nameValue);
        setHasSameName(isNameInProducts);
    };

    const poNumberHandler = (event: ChangeEvent<HTMLInputElement>) => {
        const poNumberValue = event.target.value;
        setPoNumber(poNumberValue);
        validateExtension(poNumberValue, "poNumber");
    };

    const userNamerHandler = (event: ChangeEvent<HTMLInputElement>) => {
        const userNameValue = event.target.value;
        setUerName(userNameValue);
        validateExtension(userNameValue, "userName");
    };

    const validateSubmitEnabled = () => {
        return !subscriptionNameError && !userNameError && !poNumberError;
    };
    const validateEnabled = () => {
        return !SameNameError;
    };
    // const test = () => {
    //     // setSubscriptionName("");
    //     // setQuantity("");
    //     // setSelectedProduct("");
    //     // setSubscriptionProductIsSelected([])
    // };

    const subscriptionSubmitHandler = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        // vald();
        event.preventDefault();
        if (!isSubmitted) {
            setIsSubmitted(true);
        }

        if (!validateSubmitEnabled()) {
            toasterContext.addToast({
                body: translate("Please fill all required fields"),
                messageType: "danger",
            });
            window.scrollTo(0, 0);
            return;
        }

        if (hasSameName) {
            toasterContext.addToast({
                body: translate("Create Subscription with different name"),
                messageType: "danger",
            });
            window.scrollTo(0, 0);
            return;
        }

        const QTYY = selectedSubSubscriptionList.every(abc => {
            return Number(abc.QtyOrdered) > 0;
        });
        if (!QTYY) {
            toasterContext.addToast({
                body: translate("Quantity of selected product should be greater tha 0"),
                messageType: "danger",
            });
            window.scrollTo(0, 0);
            return;
        }

        if (selectedSubSubscriptionList?.length === 0) {
            toasterContext.addToast({
                body: translate("Please select atleast 1 product "),
                messageType: "danger",
            });
            window.scrollTo(0, 0);
            return;
        }

        // if(validateForm()){
        //     toasterContext.addToast({
        //         body: translate("Please  "),
        //         messageType: "danger",
        //     });
        //     window.scrollTo(0, 0);
        //     return;
        // }

        const subscriptionData = {
            Name: subscriptionName,
            CustomerId,
            UserProfileId,
            StartDate: startDate?.toISOString() ?? "",
            EndDate: endDate?.toISOString() ?? null,
            IsActive: true,
            NextOrderFrequencyInDays: repeatPeriod,
            SubscriptionProductsList: selectedSubSubscriptionList,
            CustomerPO: poNumber,
            CustomerVatNumber: userName,
            onSuccess: () => {
                toasterContext.addToast({ body: translate("Successfull"), messageType: "success" });
                history.push("MyAccount/MySubscription");
                // test();
            },
            onError: (error: any) => {
                toasterContext.addToast({
                    body: translate("There was a problem approving the order. Please try again."),
                    messageType: "warning",
                });
            },
        };

        submitCreateSubscriptionForm(subscriptionData);
    };

    return (
        <GridContainer {...styles.subscriptionMainContainer} data-test-selector="subscription_listitems">
            <GridItem {...styles.subscriptionGirdItem}>
                <GridItem {...styles.paymentDetailsWrapper}>
                    <StyledWrapper {...styles.paymentWrap}>
                        <StyledWrapper {...styles.paymentChildrenWrap}>
                            <TextField
                                label={translate("Enter Subscription Name ")}
                                value={subscriptionName}
                                data-test-selector="subscription_Name"
                                type="text"
                                error={isSubmitted && SameNameError && subscriptionNameError}
                                onChange={subscriptionNameHandler}
                                required
                                {...styles.subscriptionNameField}
                            />
                        </StyledWrapper>

                        <StyledWrapper {...styles.paymentChildrenWrap}>
                            <TextField
                                label={translate("Po Number")}
                                value={poNumber}
                                data-test-selector="po_number"
                                type="text"
                                error={isSubmitted && SameNameError && poNumberError}
                                onChange={poNumberHandler}
                                required
                                {...styles.subscriptionNameField}
                            />
                        </StyledWrapper>

                        <StyledWrapper {...styles.paymentChildrenWrap}>
                            <TextField
                                label={translate("Enter Your Name")}
                                value={userName}
                                data-test-selector="user_name"
                                type="text"
                                error={isSubmitted && SameNameError && userNameError}
                                onChange={userNamerHandler}
                                required
                                {...styles.subscriptionNameField}
                            />
                        </StyledWrapper>
                    </StyledWrapper>
                </GridItem>

                <GridItem {...styles.dateSubmitWrapper}>
                    <StyledWrapper {...styles.dateWrapper}>
                        <DatePicker
                            {...styles.startDatePicker}
                            label={translate("Start Date")}
                            selectedDay={startDate}
                            onDayChange={startDateChangeHandler}
                        />
                        <StyledWrapper {...styles.NoendDateWrapper}>
                            <DatePicker
                                {...styles.endDatePicker}
                                label={translate("End Date")}
                                selectedDay={endDate}
                                dateTimePickerProps={{ minDate: startDate }}
                                onDayChange={endDateChangeHandler}
                            />
                            <Checkbox checked={!hasEndDate} onChange={hasEndDateChangeHandler}>
                                {translate("No end date")}
                            </Checkbox>
                        </StyledWrapper>
                        <RadioGroup
                            as="legend"
                            label={translate("Frequency")}
                            {...styles.radioGroup}
                            value={repeatPeriod}
                            defaultValue="14"
                            onChangeHandler={repeatPeriodChangeHandler}
                        >
                            <StyledWrapper {...styles.radioWrapper}>
                                <Radio {...styles.radioButton} key="7" value="7">
                                    {translate("Weekly")}
                                </Radio>
                                <Radio {...styles.radioButton} key="14" value="14">
                                    {translate("Biweekly")}
                                </Radio>
                                <Radio {...styles.radioButton} key="30" value="30">
                                    {translate("Monthly")}
                                </Radio>
                                <Radio {...styles.radioButton} key="90" value="90">
                                    {translate("Quarterly")}
                                </Radio>
                            </StyledWrapper>
                        </RadioGroup>
                    </StyledWrapper>

                    <Button {...styles.submitButton} onClick={subscriptionSubmitHandler}>
                        {translate("submit")}
                    </Button>
                </GridItem>

                {SubscribedProducts?.length && Object.keys(realtimeProductList).length ? (
                    SubscribedProducts.map((product: { [x: string]: any }, index: React.Key | undefined) => {
                        const productId = product["productId"];
                        return (
                            <SubscriptionProductList
                                product={product}
                                productInfo={realtimeProductList?.[productId]}
                                key={index}
                                updateUnitOfMeasure={updateUnitOfMeasure}
                                updateQuantity={updateQuantity}
                                setSubscriptionProductIsSelected={setSubscriptionProductIsSelected}
                                selectedSubSubscriptionList={selectedSubSubscriptionList}
                                allListOfProducts={SubscribedProducts}
                                editProductPageFlag={false}
                            />
                        );
                    })
                ) : (
                    <StyledWrapper {...styles.centeringWrapper}>
                        <LoadingSpinner {...styles.spinner} data-test-selector="productListCardListSpinner" />
                    </StyledWrapper>
                )}
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CreateSubsciptions),
    definition: {
        group: "Basic",
        displayName: "Create Subscription",
    },
};

export default widgetModule;
